import { memo, useEffect } from "react";
import styled from "styled-components";
import { Button, Card, Select, TextField } from "../../ui";
import { useNavigate, useParams } from "react-router-dom";
import fields from "./fields";
import { useYear } from "./provider";
import TextArea from "../../ui/TextArea";
import { useStatus } from "../../services/StatusProvider";
import { Icon } from "@mui/material";

const Grid = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    font-size: 20px;
    font-weight: bold;
    display: flex;
    align-items: center;
    line-height: 0;
  }
`;

const Grid2 = styled.div`
  max-width: 710px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  row-gap: 0;
`;

function ViewYear() {
  const params = useParams();
  const navigate = useNavigate();

  const {
    state: { selected },
    fetchOne,
  } = useYear();

  useEffect(() => {
    fetchOne(params.id);
  }, [params.id, fetchOne]);
  const {
    state: { isAcc },
  } = useStatus();
  console.log(selected , 'selected');
  if (!selected || selected.id !== Number(params.id)) return;

  return (
    <div>
      <Grid>
        <h2 style={{ marginTop: "0" }}>Year Information</h2>
        {isAcc && ( <div style={{ cursor: "pointer" }}>
          <Button
            style={{
              paddingRight: "40px",
              paddingLeft: "40px",
              marginLeft: "30px",
            }}
            iconName="pen"
            className="small"
            onClick={() => navigate(`/year/edit/${params.id}`)}
          >
            Edit
          </Button>
          
        </div>)}

      </Grid>
      <Card>
        <Grid2>
          {fields
            .filter((f) => !f.viewDisabled)
            .map((f) => {
              const name = f.viewName || f.name;
              let value =
                f.type === "date"
                  ? new Date(selected[name]).toLocaleDateString("fr-FR")
                  : selected[name];
              if (name === "departments")
                value = value.map((v) => v.departmentName).join(", ");
              return (
                <TextField
                  key={name}
                  label={f.label}
                  inputProps={{
                    value,
                    readOnly: true,
                    disabled: true,
                  }}
                />
              );
            })}
          <TextField
            required
            label="is Locked"
            name="islocked"
            style={{ marginBottom: "10px" }}
            inputProps={{

              value: selected?.isLocked == true ? 'Locked' : 'not Locked',
              disabled: true,
            }}
          />
        </Grid2>
        <TextArea
          style={{ maxWidth: "1200px", marginTop: "20px" }}
          label="notes"
          name="notes"
          rows="5"
          value={selected?.notes}
          inputProps={{
            disabled: true,
          }}
        />
      </Card>
    </div>
  );
}

export default memo(ViewYear);
